export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST';
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS';
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL';
export const ORDER_DETAILS_RESET = 'ORDER_DETAILS_RESET';

export const ORDER_COM_REQUEST = 'ORDER_COM_REQUEST';
export const ORDER_COM_SUCCESS = 'ORDER_COM_SUCCESS';
export const ORDER_COM_FAIL = 'ORDER_COM_FAIL';
